import React from 'react';

import './table-doc.scss';

interface TableDocProps {
  docs: React.ReactNode[];
  title: string;
}

const TableDoc: React.FC<TableDocProps> = ({ docs, title }) => (
  <div className="table-doc">
    <div className="table-doc__header">{title}</div>
    {docs.map((item, index) => (
      <div key={index} className="table-doc__item">
        {item}
      </div>
    ))}
  </div>
);

export default TableDoc;
